<template>
    <header class="header-toolbar" data-qa="header-toolbar">
        <div class="header-title">
            <DsIconButton
                class="arrow"
                name="arrow-left"
                data-qa="back-button"
                aria-label="Back"
                :disabled="disabled"
                @click="$emit('back')"
            />

            <div class="broadcast-info">
                <div class="broadcast-name" data-qa="broadcast-subject">
                    <span class="broadcast-subject">{{ subject }}</span>

                    <EmailBroadcastStatusChip
                        class="only-desktop"
                        data-qa="email-broadcast-status"
                        :broadcast="broadcast"
                    />
                </div>

                <div
                    v-if="updatedTime"
                    class="broadcast-updated only-desktop"
                    data-qa="broadcast-updated-time"
                >
                    {{ updatedTime }}
                </div>
            </div>
        </div>

        <div class="header-actions">
            <DsOutlineButton
                data-qa="send-test-button"
                class="only-desktop"
                :disabled="disabled"
                :loading="loadingSendTest"
                @click="$emit('send-test')"
            >
                {{ $options.MESSAGE_CONSTANTS.SEND_TEST }}
            </DsOutlineButton>

            <DsButton
                data-qa="send-broadcast-button"
                class="send-broadcast"
                :disabled="disabled"
                :loading="loading"
                @click="$emit('send')"
            >
                <span class="only-desktop">
                    {{ shouldSendNow ? $options.MESSAGE_CONSTANTS.SEND_BROADCAST : $options.MESSAGE_CONSTANTS.SCHEDULE_BROADCAST }}
                </span>

                <span class="only-mobile">
                    {{ shouldSendNow ? $options.MESSAGE_CONSTANTS.SEND : $options.MESSAGE_CONSTANTS.SCHEDULE }}
                </span>
            </DsButton>
        </div>
    </header>
</template>

<script>
import EmailBroadcastStatusChip from '@/components/broadcast/email/EmailBroadcastStatusChip';
import { MESSAGE_CONSTANTS } from '@/components/broadcast/constants/emailBroadcast.constants';
import { broadcastDateMessage } from '@/components/broadcast/utils/date.util';

export default {
    MESSAGE_CONSTANTS,

    components: {
        EmailBroadcastStatusChip,
    },

    props: {
        broadcast: {
            type: Object,
            required: true,
        },
        disabled: Boolean,
        loading: Boolean,
        shouldSendNow: Boolean,
        loadingSendTest: Boolean,
    },

    computed: {
        subject() {
            return this.broadcast.template?.subject || this.$options.MESSAGE_CONSTANTS.NO_SUBJECT;
        },

        updatedTime() {
            return this.broadcast.lastEdit ? broadcastDateMessage(this.broadcast) : null;
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../../styles/common";

.arrow {
    @include margin-end($spacing-100);
}

.header-toolbar {
    @media ($extra-small) {
        padding: $spacing-200 $spacing-200 $spacing-200 $spacing-100;
    }

    padding: $spacing-200;
    display: flex;
    height: px-to-rem(72);
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $color-gray-200;
}

.header-title {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
}

.broadcast-info {
    padding-left: $spacing-100;
    display: flex;
    flex: 1;
    overflow: hidden;
    flex-direction: column;
}

.broadcast-name {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: $spacing-100;
    font-size: $font-size-lg;
    margin-right: $spacing-200;
}

.broadcast-subject {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
}

.broadcast-updated {
    font-size: $font-size-xs;
}

.header-actions {
    display: flex;
    gap: $spacing-100;
}

.send-broadcast {
    @media ($extra-small) {
        @include margin-start($spacing-100);
    }
}
</style>
